import { NgModule } from '@angular/core';

import { QuillEditorComponent } from './quillEditor.component';

@NgModule({
  declarations: [
    QuillEditorComponent
  ],
  exports: [
    QuillEditorComponent
  ]
})
export class QuillEditorModule {}



// WEBPACK FOOTER //
// ./~/ngx-quill-editor/quillEditor.module.ts